//page-top
document.getElementById('page-top').addEventListener('click', function (e) {
  e.preventDefault();

  const target = document.getElementById('MainContent');
  target.scrollIntoView({
    behavior: 'smooth'
  });
});

//accordion
const accordion = document.querySelector('.accordion');
const arrowIcon = document.querySelector('.arrow-icon');

accordion.addEventListener('toggle', () => {
  if (accordion.open) {
    arrowIcon.style.transform = 'rotate(180deg)';
  } else {
    arrowIcon.style.transform = 'rotate(0deg)';
  }
});

// メガメニュー幅
const headerInlineMenu = document.querySelector('.header__inline-menu');

if (headerInlineMenu) {
  const headerInlineMenuWidth = headerInlineMenu.offsetWidth;
  const megaMenus = document.querySelectorAll('.mega-menu__content');

  megaMenus.forEach(menu => {
    menu.style.width = headerInlineMenuWidth + 'px';
  });
}

// メガメニューホバーで実行
const headerMenu = document.getElementById('HeaderMenu-designers');
const megaMenuContent = document.getElementById('MegaMenu-Content-2');

if (headerMenu && megaMenuContent) {
  // MegaMenuから出た時に再click
  megaMenuContent.addEventListener('mouseleave', () => {
    headerMenu.click();
  });
}

// メガメニューリンク
const link1 = document.getElementById('HeaderMenu-designers-top-designers');
if (link1) {
  link1.href = link1.href.split('#')[0] + '#top_designer';
}

const link2 = document.getElementById('HeaderMenu-designers-designers');
if (link2) {
  link2.href = link2.href.split('#')[0] + '#designer';
}